import { useHistory } from 'react-router';
import MaterialIcon from 'src/new_arch/modules/ui/components/Icon/MaterialIcon/MaterialIcon';
import { useState } from 'react';
import { HoverCard } from '@mantine/core';
import CardBenefitInformation from 'src/components/CardBenefitInformation/CardBenefitInformation';
import Button from '../../../components/Button/Button';
import useFetchCurrentUserQuery from '../../authentication/queries/useFetchCurrentUserQuery';
import useLogout from '../../authentication/queries/useLogout';

import './FreeAccountPushForGuestsButton.scss';

const FreeAccountPushForGuestsButton = () => {
	const { data: currentUser } = useFetchCurrentUserQuery();
	const { logout } = useLogout();
	const history = useHistory();
	const [ hovered, setHovered ] = useState( false );
	const onSignUpClicked = ( event : React.MouseEvent ) => {
		event.preventDefault();
		logout();
		history.replace( '/signup', {
			isGuestSignup: true,
			email: currentUser?.email
		} );
	}

	return (
		<HoverCard width={280} shadow="md">
			<HoverCard.Target>
				<div
					onMouseEnter={() => setHovered( true )}
					onMouseLeave={() => setHovered( false )}
				>
					<Button
						onClick={onSignUpClicked}
						className="FreeAccountPushForGuestsButton"
					>
						<span className="button-icon">
							<MaterialIcon icon={hovered ? 'lock-open-icon' : 'lock-icon'} size={18} color={hovered ? '#1C91FF' : '#7B8CA7'} />
						</span>
						<span> Create Free Account</span>
					</Button>
				</div>
			</HoverCard.Target>
			<HoverCard.Dropdown p={0}>
				<CardBenefitInformation />
			</HoverCard.Dropdown>
		</HoverCard>
	);
};

export default FreeAccountPushForGuestsButton;
